var url = "493ca3ce7fa45358a69ae81f8c23e5e8.jpeg";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;